export default function selectNotEpty(element, data) {
    element.addEventListener("change", update);
    update();

    function update() {
        const value = element.value;
        element.classList.toggle("not-empty", value != null && value != undefined && value != "");
    }
}
